export const createSchedule = (schedule) => {
    let scheduleDays = {};
    /*  schedule.forEach((sch) => {
      scheduleDays[new Date(sch.date).toISOString()] = [];
    }); */
    schedule.forEach((sch) => {
        if (!Object.hasOwn(scheduleDays, `${new Date(sch.date).toDateString()}`)) {
            scheduleDays[new Date(sch.date).toDateString()] = [];
        }
        scheduleDays[new Date(sch.date).toDateString()].push(sch);
    });
    return scheduleDays;
};
